
import _ from 'lodash'
import { mapActions } from 'vuex'
import ButtonMinus from './ButtonMinus'
import ButtonDelete from './ButtonDelete'
import ButtonPlus from './ButtonPlus'
import cart from '~/mixins/cart'
import practiceLocation from '~/mixins/practiceLocation'
import { api, getJsonApiHeaders } from '~/config/api'
import {
  RESPONSE_STATUS_NO_CONTENT,
  RESPONSE_STATUS_OK,
} from '~/ZenOne-StoryBook/helpers/response'
import '~/assets/styles/components/setQtyInCart.scss'
import { CART_ITEM_SELECTION_TYPE } from '~/store/modules/shopping_cart/helper'

export default {
  name: 'SetQtyInCart',
  components: { ButtonPlus, ButtonDelete, ButtonMinus },
  mixins: [cart, practiceLocation],
  props: {
    productDistributor: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      blockControls: false,
      value: this.getInitialValue(),
      onFocus: this.getInitialValue(),
      inputIsFocused: false,
    }
  },
  computed: {
    showMinusBtn() {
      return this.value > 1
    },
  },
  watch: {
    productDistributor: {
      deep: true,
      handler(productDistributorNew, productDistributorOld) {
        const {
          cartItem: { qty: qtyNew = 0 },
        } = productDistributorNew
        const {
          cartItem: { qty: qtyOld = 0 },
        } = productDistributorOld
        if (qtyNew !== qtyOld) {
          this.onFocus = qtyNew
          this.value = qtyNew
        }
      },
    },
    isPriceLoading: {
      immediate: true,
      handler(isPriceLoading) {
        this.blockControls = isPriceLoading
      },
    },
  },
  methods: {
    ...mapActions({
      removeCartItemIds: 'shoppingCart/removeCartItemIds',
      removeItemsFromSelected: 'shoppingCart/removeItemsFromSelected',
    }),
    getInitialValue() {
      return this.productDistributor?.cartItem?.qty ?? 0
    },
    async onDecreaseQty() {
      await this.decreaseQuantity()
    },
    async onIncreaseQty() {
      await this.increaseQuantity()
    },
    onDebounce: _.debounce(async function () {
      await this.updateQuantity()
    }, 1000),
    async updateQuantity() {
      if (this.blockControls) return false
      const { value = '' } = this
      if (value === '0' || !value) {
        this.value = this.onFocus
        return false
      }
      const qty = parseInt(this.value)
      try {
        this.blockControls = true
        this.inputBlur()
        const cartItemId = this?.productDistributor?.cartItem?.id ?? null
        if (!cartItemId) {
          throw new Error('No cart item id')
        }
        const res = await this.$axios.patch(
          `${api.CART_ITEMS}/${cartItemId}`,
          {
            data: {
              type: `${api.CART_ITEMS}`,
              id: `${cartItemId.toString()}`,
              attributes: {
                qty,
              },
            },
          },
          getJsonApiHeaders()
        )
        if (res?.status !== RESPONSE_STATUS_OK) {
          throw new Error('Network Error: ' + res.status)
        }
        this.changeQtyEmit(qty, cartItemId, true)
      } catch (e) {
        console.error(`Update quantity was failed: ${e}`)
      } finally {
        this.blockControls = false
      }
    },
    async removeProductFromCart() {
      const cartItemId = this?.productDistributor?.cartItem?.id ?? null
      try {
        this.blockControls = true
        if (!cartItemId) {
          throw new Error('No cart item id')
        }

        const res = await this.$axios.delete(
          `${api.CART_ITEMS}/${cartItemId}`,
          getJsonApiHeaders()
        )
        if (res?.status !== RESPONSE_STATUS_NO_CONTENT) {
          throw new Error('Network Error: ' + res.status)
        }
        this.changeQtyEmit(0, null, false)
        this.removeCartItemIds({ ids: [cartItemId] })
        this.removeItemsFromSelected({
          type: CART_ITEM_SELECTION_TYPE,
          ids: [cartItemId],
        })
        await this.setCartItemsCount()
        this.$emit('removedFromCart')
      } catch (e) {
        console.error(`Delete cart item failed: ${e}`)
      } finally {
        this.blockControls = false
      }
    },
    decreaseQuantity() {
      const { value: qty } = this
      if (qty === 1) return false
      this.value = parseInt(qty) - 1
      this.onDebounce()
    },
    increaseQuantity() {
      const { value: qty } = this
      this.value = parseInt(qty) + 1
      this.onDebounce()
    },
    keyPressHandler(e) {
      if (!e.key.match(/[0-9]/g)) {
        e.preventDefault()
      }
    },
    applyHandler() {
      this.updateQuantity()
    },
    inputBlur() {
      if (this.$refs.input) {
        this.$refs.input.blur()
      }
    },
    focusInHandler() {
      this.inputIsFocused = true
      this.onFocus = this.value
    },
    focusOutHandler() {
      this.inputIsFocused = false
      if (this.value !== this.onFocus) {
        this.updateQuantity()
      }
    },
    changeQtyEmit(qty = 0, cartItemId = null, addedShoppingCart = false) {
      try {
        const productDistributorId = this.productDistributor?.id
          ? parseInt(this.productDistributor.id)
          : null
        if (!productDistributorId) {
          throw new Error('No product distributor id')
        }
        this.$emit('onChangeQtyInCart', {
          productDistributorId,
          cartItem: {
            id: cartItemId ? parseInt(cartItemId) : null,
            qty,
          },
          addedShoppingCart,
        })
      } catch (e) {
        console.error(`Update product list error: ${e}`)
      }
    },
  },
}
